import React from "react";
import CustomizedDialogs from "./Dialog";
import { StyledTableRow, StyledTableCell } from "./CommonStyles";

function CollapseRow(props) {
  const { lineNo, formData, openDialog, post, csvUplaodEnabled } = props;
  return (
    <React.Fragment>
      {lineNo.map((value, key) => {
        // Search ALL formData entries to find the one containing this label's table rows
        let filteredArray = undefined;
        let baseDataIndex = 0;
        for (let fi = 0; fi < formData.length; fi++) {
          const entry = formData[fi];
          if (!value || !value.TableName || !Array.isArray(entry?.[value.TableName])) continue;
          if (value.PO) {
            // PO-based filtering — filter by PO and also by label when available
            let matches = entry[value.TableName].filter(
              (item) => item["ORDER Nº"] === value.PO
            );
            if (matches.length > 0 && value.LabelFieldName && value.ProductDesc) {
              // Only apply label sub-filter if the rows actually contain the label field
              const rowsHaveLabelField = matches.some(
                (item) => value.LabelFieldName in item
              );
              if (rowsHaveLabelField) {
                matches = matches.filter(
                  (item) => item[value.LabelFieldName] === value.ProductDesc
                );
              }
            }
            if (matches.length > 0) {
              filteredArray = matches;
              baseDataIndex = fi;
              break;
            }
          } else if (value.LabelFieldName && value.ProductDesc) {
            // Label-based filtering
            const matches = entry[value.TableName].filter(
              (item) => item[value.LabelFieldName] === value.ProductDesc
            );
            if (matches.length > 0) {
              filteredArray = matches;
              baseDataIndex = fi;
              break;
            }
          }
        }
        // Build dialog data: merge filtered table into full data object to preserve headers
        // Keep all non-table arrays (CCL, FibreList, etc.) — Dialog.js handles table filtering
        let dialogFormData;
        let dialogKey2;
        if (filteredArray) {
          const baseData = formData[baseDataIndex] || formData[0];
          dialogFormData = { ...baseData, [value.TableName]: filteredArray };
          dialogKey2 = baseDataIndex;
        } else if (formData.length > 1) {
          dialogFormData = formData[key] || formData[0];
          dialogKey2 = key < formData.length ? key : 0;
        } else {
          dialogFormData = formData[0];
          dialogKey2 = 0;
        }
        return (
          <StyledTableRow key={key}>
            {csvUplaodEnabled && <StyledTableCell>{value.PO}</StyledTableCell>}
              {openDialog && !value.isImpliedItem ? (
              <StyledTableCell>
                <CustomizedDialogs
                  diaglogTitle={value.LineNo}
                  formData={dialogFormData}
                  key2={dialogKey2}
                  post={post}
                  PO={value.PO}
                  ProductDesc={value.ProductDesc}
                  TableName={value.TableName}
                />
              </StyledTableCell>
            ) : (
              <StyledTableCell> {value.LineNo} </StyledTableCell>
            )}
            <StyledTableCell>{value.ProductDesc}</StyledTableCell>
            <StyledTableCell>{value.Quantity}</StyledTableCell>
          </StyledTableRow>
        );
      })}
    </React.Fragment>
  );
}

export default CollapseRow;
